import { useEffect, useState } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import { tableViewVM } from '../../../../core/table/table_view_models';
import viewStateRepo from '../../../../core/repo/viewStateRepo';

// provider imports
import { PROVIDER_LIST_STORAGE_KEY, PROVIDER_LIST_VIEW_KEY } from '../../provider_const';
import {
    tableFiltersAtom,
    tableStateAtom,
    tableStatsAtom,
    tableViewAtom,
    setAtomProviderListTableViewState,
} from '../provider_list_atoms';
import { providerListColumnSpec, providerListDefaultView } from './ProviderListTableSpec';
import { tblSpecLoadStorage, tblSpecLoadView } from '../../../../core/table/tableViewsRepo';

export const useProviderListTableInit = (): boolean => {
    const [init, setInit] = useState(true);

    const setTableState = useSetImmerAtom(tableStateAtom);
    const setView = useSetImmerAtom(tableViewAtom);
    const setStats = useSetImmerAtom(tableStatsAtom);
    const setFilter = useSetImmerAtom(tableFiltersAtom);

    // INIT: only do the table, not the search form
    useEffect(() => {
        if (init) {
            setInit(false);
            setTableState(draft => {
                // load custom views from storage
                const colSpec = providerListColumnSpec();
                const defaultView = providerListDefaultView();
                const viewStorage = tblSpecLoadStorage(PROVIDER_LIST_VIEW_KEY, colSpec, defaultView);
                draft.views = viewStorage.views;
                draft.currentViewId = viewStorage.current;

                // set current view
                setView(() => tblSpecLoadView(viewStorage.current, viewStorage.views, colSpec) || tableViewVM());

                // viewstate filters and paging
                const viewstate = viewStateRepo.getTable(PROVIDER_LIST_STORAGE_KEY, Array.from(colSpec.keys()));
                if (!!viewstate) {
                    console.log('ProviderListTable INIT: loading viewstate=', JSON.stringify(viewstate));
                    setView(draft => {
                        draft.sort = viewstate.sort;
                    });
                    setFilter(() => viewstate.flt);
                    setStats(draft => {
                        draft.paging = viewstate.paging;
                    });
                }
                return draft;
            });
        }
    }, [init, setTableState, setView, setFilter, setStats]);

    useEffect(() => {
        return (): void => {
            setAtomProviderListTableViewState();
        };
    }, [setTableState, setView, setFilter, setStats]);

    return init;
};
